import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang, pick, formatPrice } from "../lib/i18n";

export const ProductCard = ({ p, index, total, className = "" }) => {
  const { lang } = useLang();
  const street = p.world === "street";
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 1, ease: [0.19, 1, 0.22, 1] }}
    >
      <Link to={`/product/${p.id}`} data-testid={`product-card-${p.id}`} className="group block">
        <div className={`relative aspect-[3/4] overflow-hidden ${street ? "bg-[#14161a]" : "bg-[#e9e2d5]"}`}>
          <div className="frame-clip absolute inset-0">
            <img src={p.images?.[0]} alt={pick(p, "name", lang)} loading="lazy" className="w-full h-full object-cover scale-[1.04] transition-transform [transition-duration:1200ms] ease-out group-hover:scale-110" />
          </div>
          {p.tag && (
            <span className={`absolute top-5 left-5 px-2 py-1 f-mono text-[11px] uppercase tracking-[0.2em] ${street ? "bg-[var(--acid)] text-black" : "bg-[var(--ivory)] text-[var(--navy)]"}`}>{p.tag}</span>
          )}
          <span className={`absolute top-5 right-5 f-mono text-[11px] ${street ? "text-white/80" : "text-white"}`}>
            {String(index + 1).padStart(2, "0")}/{String(total).padStart(2, "0")}
          </span>
        </div>
        <div className="flex items-start justify-between gap-4 mt-5">
          <h3 className={street ? "f-street uppercase text-2xl md:text-3xl leading-none" : "f-serif text-2xl md:text-[1.7rem] leading-tight"}>
            {pick(p, "name", lang)}
          </h3>
          <span data-testid={`product-price-${p.id}`} className="f-mono text-[13px] whitespace-nowrap pt-1">{formatPrice(p.price)}</span>
        </div>
      </Link>
    </motion.div>
  );
};
